import { useEffect, useState } from "react";

export default function HeroImageCropDialog({
  file,
  variant,
  spec,
  onCancel,
  onCrop,
}) {
  const [zoom, setZoom] = useState(1),
    [x, setX] = useState(0.5),
    [y, setY] = useState(0.5),
    [size, setSize] = useState(null),
    [source, setSource] = useState("");
  useEffect(() => {
    const reader = new FileReader();
    reader.onload = () => setSource(reader.result);
    reader.readAsDataURL(file);
  }, [file]);
  const ratio = spec.width / spec.height,
    sourceRatio = size ? size.width / size.height : ratio,
    baseWidth = size
      ? sourceRatio > ratio
        ? size.height * ratio
        : size.width
      : 1,
    cropWidth = baseWidth / zoom,
    cropHeight = cropWidth / ratio,
    previewWidth = spec.height > spec.width ? 280 : 480,
    previewHeight = previewWidth / ratio,
    scale = previewWidth / cropWidth;
  const crop = () => {
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = spec.width;
      canvas.height = spec.height;
      canvas
        .getContext("2d")
        .drawImage(
          image,
          (size.width - cropWidth) * x,
          (size.height - cropHeight) * y,
          cropWidth,
          cropHeight,
          0,
          0,
          spec.width,
          spec.height,
        );
      canvas.toBlob(
        (blob) =>
          blob &&
          onCrop(
            new File([blob], `${variant}-hero.jpg`, { type: "image/jpeg" }),
          ),
        "image/jpeg",
        0.92,
      );
    };
    image.src = source;
  };
  const slider = (label, value, setter, min, max) => (
    <label
      style={{
        display: "block",
        marginBottom: 12,
        fontSize: 13,
        fontWeight: 600,
      }}
    >
      {label}
      <input
        type="range"
        min={min}
        max={max}
        step=".01"
        value={value}
        onChange={(event) => setter(Number(event.target.value))}
        style={{ width: "100%", marginTop: 5 }}
      />
    </label>
  );
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={`Crop ${spec.label} hero image`}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1001,
        padding: 20,
        background: "rgba(15,23,42,.82)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "min(620px, 100%)",
          maxHeight: "calc(100vh - 40px)",
          overflowY: "auto",
          borderRadius: 12,
          padding: 20,
          background: "#fff",
        }}
      >
        <h2 style={{ margin: "0 0 6px", fontSize: 18 }}>
          Crop {spec.label} hero image
        </h2>
        <p style={{ margin: "0 0 16px", fontSize: 13, color: "#64748b" }}>
          The cropped image will be exported at exactly {spec.width} ×{" "}
          {spec.height}px.
        </p>
        {size ? (
          <div
            style={{
              width: previewWidth,
              maxWidth: "100%",
              height: previewHeight,
              maxHeight: "55vh",
              margin: "0 auto 16px",
              overflow: "hidden",
              background: "#0f172a",
              borderRadius: 8,
              position: "relative",
            }}
          >
            <img
              src={source}
              alt="Crop preview"
              style={{
                position: "absolute",
                width: size.width * scale,
                height: size.height * scale,
                maxWidth: "none",
                transform: `translate(${-((size.width - cropWidth) * x) * scale}px, ${-((size.height - cropHeight) * y) * scale}px)`,
              }}
            />
          </div>
        ) : (
          source && (
            <img
              src={source}
              alt="Loading crop editor"
              onLoad={(event) =>
                setSize({
                  width: event.currentTarget.naturalWidth,
                  height: event.currentTarget.naturalHeight,
                })
              }
              style={{ display: "none" }}
            />
          )
        )}
        {size && (
          <>
            {slider("Zoom", zoom, setZoom, 1, 3)}
            {slider("Horizontal position", x, setX, 0, 1)}
            {slider("Vertical position", y, setY, 0, 1)}
          </>
        )}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <button type="button" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="primary"
            disabled={!size}
            onClick={crop}
          >
            Crop & upload
          </button>
        </div>
      </div>
    </div>
  );
}
